<template>
    <actions-menu v-model:dialogEdit="dialog2" v-model:dialogDelete="dialog" :Id="Id" />

    <AddProductsPrice v-model="dialog2" @add-ProductsPrice-close-dialog="dialog2 = false"
        @reloadListProductsPrice="reloadListProductsPrice" ref="AddProductsPricesRef" :ProductPrice="ProductPrice"
        :ProductVariants="ProductVariants" />

</template>
<script>
import actionsMenu from "@/genericComponent/actionsMenu.vue"
import AddProductsPrice from "./AddProductsPrice.vue";

export default {
    props: ['ProductPrice', 'getPriceListProductAfterUpdate', "Id", "ProductVariants"],
    components: { actionsMenu, AddProductsPrice },
    data() {
        return {
            dialog: false,
            dialog2: false,
            msg: [],
            validationButton: false
        };
    },
    watch: {
        dialog2() {
            this.msg = []
        },
    },
    methods: {
        ActiveDeletedSnackBar() {
            this.getParent('MainLayout').ActiveDeletedSnackBar();
        },
        ActiveWarningSnackBar() {
            this.getParent('MainLayout').ActiveWarningSnackBar();
        },
        ActiveSavedSnackBar() {
            this.getParent('MainLayout').ActiveSavedSnackBar();
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        reloadListProductsPrice() {
            this.getPriceListProductAfterUpdate()
        },
    },
};
</script>
<style scoped>
h1 {
    font-family: inter;
    font-size: 18px;
    line-height: 29px;
    font-weight: 600;
    color: #0d0849;
    text-align: center;
}

.v-card-title {
    font-family: inter;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    color: #0d0849;
    margin-left: 40px;
    margin-top: -30px;
}

.v-card-text {
    margin-left: 40px;
    font-family: inter;
    font-size: 12px;
    line-height: 16px;
    font-weight: 500;
    color: #768da9;
    margin-top: -20px;
}

.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    margin-bottom: 5px;
}
</style>